<template>
  <div>
    <v-card style="margin: 5px; ">
      <!-- Image w/gradient -->
      <v-img :src="image" aspect-ratio="2.75" gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)">
        
        <!-- Overlay title, subtitle and link on image -->
        <v-container fill-height fluid>
          <v-layout align-center justify-center row wrap fill-height>
            <v-flex xs12><span class="headline" style="color: white">{{title}} </span></v-flex>
            <v-flex xs12><div style="color: white">{{subtitle}}</div></v-flex>
            <v-flex xs12> <v-btn color="primary" :to="link">Read</v-btn>  </v-flex>
          </v-layout>
        </v-container>

      </v-img>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'update-card',
  data() {
    return {};
  },
  computed: {
    update() { return this.$store.state.updates[this.storeIndex]; },
    title() { return this.update.title; },
    subtitle() { return this.update.subtitle; }, 
    image() { return require(`../assets/${this.update.image}`); }, 
    link() { return `/updates/${this.update.component}`; }
  },
  props: ['storeIndex'],
};
</script>

<style>

</style>

